export default {
  menu: {
    myOkr: 'My OKR',
    leaders: 'My Leaders',
    subordinates: 'My Subordinates',
    followings: 'My Followings',
    team: 'Team',
    departmentsSupported: 'Team Supported',
    report: 'Report',
    reportOverview: 'Overview Analysis',
    reportDepartment: 'Comparative Analysis',
    myTeamOkrWeek: 'My Team Okr Week',
    alignmentMap: 'Map'
  },
  header: {
    customerServiceGroup: 'Service on-call',
    backToOld: 'Back to Old',
    searchPlaceholder: 'Input nickname or name to view other\'s OKR',
    vipGroupSrc: require('@/assets/images/vip-group-en.png'),
    dropdownMenu: {
      okrConcept: {
        title: 'What is OKR',
        url: 'https://funplus.feishu.cn/wiki/X3m9w02phibkDtkpvm7chBhpnHe'
      },
      newFeatures: {
        title: 'New Features',
        url: 'https://funplus.feishu.cn/wiki/OIAewN1fmihSWAkNryDcLULInuf'
      },
      manual: {
        title: 'User Manual',
        url: 'https://funplus.feishu.cn/wiki/P6whwOPPnizC83kwqP2cbyS8nhc'
      }
    }
  }
}
